import React, {useEffect, useState, useMemo, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus } from "@fortawesome/free-solid-svg-icons";
import zoologyinnerimg from '../assets/images/zoologyinnerimg.webp';
import { useParams } from "react-router-dom";
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/Config";
import Spinner from "react-activity/dist/Spinner";
ModuleRegistry.registerModules([ClientSideRowModelModule]);


const MSczoologyinnerpage = () => {
    const { courseslug, year } = useParams();
        const [showloading, setshowloding] = useState(false);
        const [coursedetails, setcoursedetails] = useState({});
        const [foldersdata, setfoldersdata] = useState([]);

        const [rowData, setRowData] = useState([]);
          const [colDefs, setColDefs] = useState([]);
          const paginationPageSizeSelector = useMemo(() => {
            return [10, 20, 50, 100];
          }, []);

        const navigate = useNavigate();

    const viewbatchhandle = (year) => {
        console.log('hello world!!');
        navigate('/course/'+courseslug+'/'+year);
    }

    const fetchcoursedetails = async(course, year) => {
        var data = {
            courseslug: course,
            year: year
          }
  
          const headers = {
            headers: {
              "Content-Type": "application/json"
            },
          };
  
          let resp = await axios
          .post(apiUrl + "getusercoursedetailsbyyear", data, headers)
          .then((res) => {
            // console.log('res >>>', res.data)
            if (res.data.status == "success") {
              setshowloding(false);

              if(res?.data?.coursedetail) {
                setcoursedetails(res?.data?.coursedetail);
              } else {
                setcoursedetails({});
              }

              if(res?.data?.data?.length > 0) {
                setfoldersdata(res?.data?.data);
              } else {
                setfoldersdata([]);
              }
              
              // window.location.reload();
              
              setshowloding(false);
            } else {
              setshowloding(false);
            }
          })
          .catch((err) => {
            setshowloding(false);
            alert(err.message);
          });
    }

    const fetchallcourses = async (course, year) => {
      setshowloding(true);
      var data = {
        courseslug: course,
        year: year
      }
      const headers = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let resp = await axios
        .post(apiUrl + "getusercoursedetailsbyyear",data, headers)
        .then((res) => {
          if (res.data.status == "success") {
            // console.log('getallcategories >>', res.data);
            var prevdata = res.data.data;
            if(prevdata?.length > 0) {
              var columnsarr = [];
              var hidecolumns = ['id', 'created_at', 'updated_at', 'sort', 'image', 'status', 'categoryid', 'description', 'facebook', 'twitter', 'linkedin', 'instagram', 'pinterest', 'slug', 'phonenumber'];
              var columns = Object.keys(prevdata[0]);
              // console.log('columns  >>>', columns );
              for(var i = 0; i < columns?.length;i++) {
                if(!hidecolumns.includes(columns[i])) {
                  var obj = {};
                  obj.field = columns[i];
                  // console.log('obj >>', obj)
                  columnsarr.push(obj);
                }
              }
             

            
               //status
           
              setColDefs(columnsarr);
              setRowData(prevdata);
            } else {
              setColDefs([]);
              setRowData([]);
            }
            
            // setcoursesdata(res.data.data);
          } else {
            // alert(res.data.message);
            
          }
        })
        .catch((err) => {
          alert(err.message);
        });
        setshowloding(false);
    };

    const defaultColDef = {
      flex: 1,
    };

    useEffect(() => {
        if(courseslug) {
          fetchallcourses(courseslug, year)
        }
    }, [courseslug, year])


    return (
        <div>
            <section className="gallery-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">{coursedetails?.name ? coursedetails?.name : ""} {year}</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                    {coursedetails?.name ? coursedetails?.name : ""} <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i> {year}</p>
                </div>
            </section>
            <section className="alumini-comitee-member-sec">
                <div className="container">
                    {/* <div className="row">

                        {
                            foldersdata?.length > 0 ?
                            foldersdata?.map((item, index) => {
                                return (
                                    <div className="col-12 col-md-6 col-lg-3 mb-2 mb-md-4">
                            <div className="">
                                <div className="hover-image-container">
                                    <img src={assetsUrl+'/registermembers/'+item?.image} alt="Hover" className="hover-image" />
                                    <div className="social-overlay">

                                    </div>
                                </div>
                            </div>
                            <p className="zoology-inner-member-name">{item?.name}</p>
                            <div className="zoology-inner-content  d-flex ">
                                <i class="fa fa-briefcase   zoology-icons-member" aria-hidden="true"></i>
                                <p className="zoology-para">{item?.designation}</p>
                            </div>
                            <div className="zoology-inner-content  d-flex " style={{marginTop: -10}}>
                                <i class="fa fa-envelope    zoology-icons-member" aria-hidden="true"></i>
                                <p className="zoology-para">{item?.email}</p>
                            </div>
                        </div>
                                )
                            }) : 
                            showloading ?
                            <div>
                                 <Spinner color='#264790' size={22} className='spinnerCenter' />
                            </div> :
                            <p className="msc-zoology-batchhead" style={{textAlign: 'center', color: '#000'}}>
                                        No data
                                      </p>
                        }

                        


                    </div> */}

                    <div
                              className={"ag-theme-quartz frontend-table"}
                            >
                              <AgGridReact
                                // modules={AllModules}
                                rowData={rowData}
                                columnDefs={colDefs}
                                defaultColDef={defaultColDef}
                                suppressRowClickSelection={true}
                                groupSelectsChildren={true}
                                rowSelection={"multiple"}
                                pagination={true}
                                paginationPageSize={10}
                                paginationPageSizeSelector={paginationPageSizeSelector}
                                // onGridReady={onGridReady}
                              />
                            </div>
                </div>
            </section>
        </div>
    )
}
export default MSczoologyinnerpage;